import request from '@/shared/api/request';

export const leaveTeam = (uuid: string): Promise<void> =>
  request({
    url: `/teams/${uuid}/`,
    method: 'DELETE',
  });
